import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { userColumns, fetchUserRows } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
import ConfirmModal from "../common/ConfirmModal";

const UserDataTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Confirm modal states
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const { slugs } = useSlug();

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const rows = await fetchUserRows();

        if (rows && rows.data && Array.isArray(rows.data)) {
          setData(rows.data);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to load users.");
        setData([]);
      }
      setLoading(false);
    };

    getData();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${serverUrl}/del_user/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete user");
      }

      setData((prev) => prev.filter((item) => item.id !== id));
      toast.success("User deleted successfully!");
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error("Failed to delete user. Please try again.");
    }
  };

  // Confirm Handlers
  const confirmDelete = () => {
    if (selectedId) {
      handleDelete(selectedId);
      setConfirmOpen(false);
      setSelectedId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setSelectedId(null);
  };

  const viewLinkString = "User-Single";
  const editLinkString = "User-Edit";
  const newLinkString = "User-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          {slugs?.includes(viewLinkString) && (
            <Link
              to={`/user/${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">View</div>
            </Link>
          )}

          {slugs?.includes(editLinkString) && (
            <Link
              to={`/user/update-user/${params.row.id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="editButton">Edit</div>
            </Link>
          )}

          <div
            className="deleteButton"
            onClick={() => {
              setSelectedId(params.row.id);
              setConfirmOpen(true);
            }}
          >
            Delete
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2">
        <div className="text-gray-700 text-2xl">Users</div>

        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs?.includes(newLinkString) && (
            <Link to="/user/new" className="commonButton">
              Add New
            </Link>
          )}
        </div>
      </div>

      {loading ? (
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={userColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      )}

      {/* Confirm Modal */}
      <ConfirmModal
        isOpen={confirmOpen}
        title="Delete User?"
        message="Are you sure you want to delete this user? This action cannot be undone."
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default UserDataTable;
